import { render, staticRenderFns } from "./BasePaperFailIcon.vue?vue&type=template&id=32dc3a87"
import script from "./BasePaperFailIcon.vue?vue&type=script&lang=js"
export * from "./BasePaperFailIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports